import {
  countryCodeColumnDefinition,
  countryNameColumnDefinition,
  currencyCodeColumnDefinition,
} from '../../../shared/columnDefinitions';

export default [
  countryCodeColumnDefinition,
  countryNameColumnDefinition,
  currencyCodeColumnDefinition,
];
